import React, { useEffect, useState } from "react";
import { hexToRgb } from "../core/colorMapService";
import './singleLayerSettingsColor.css'
import { CheckOutlined } from "@ant-design/icons";
import { Slider } from "antd";
import { getLayerLegend } from "./singleLayerService";

export function SingleLayerSettingsColor({
    colorMaps,
    colorMapName,
    setColorMapName,
    colorMapOpacity,
    setColorMapOpacity,
    data
}) {
    const [colorMapData, setColorMapData] = useState([])

    function onChangeOpacity(e) {
        setColorMapOpacity(e)
    }

    useEffect(() => {
        const tmpColorMapData2 = [];
        const fetchAndPushColorMap = (colorMap) => {
            const result = colorMap.split('-')
            if (colorMap.length > 1) {
                const colorMapName2 = result[result.length - 1]
                let buf = {}
                return getLayerLegend(data['geoserver_layer_name'], colorMap).then((response) => {
                    const Legend = response['data']['Legend'][0]['rules'][0]['symbolizers'][0]['Raster']['colormap']['entries']
                    buf['name'] = colorMapName2
                    buf['interpolate'] = false
                    let hexcolors = Legend.map(entry => entry.color)
                    let rgbcolors = hexcolors.map(hex => hexToRgb(hex))
                    buf['colors'] = rgbcolors
                    if (response['data']['Legend'][0]['rules'][0]['symbolizers'][0]['Raster']['colormap']['type'] === 'ramp') {
                        buf['is_categorical'] = false
                    } else {
                        buf['is_categorical'] = true
                    }
                    if (!buf.is_categorical) {
                        let gradientstr = 'linear-gradient(90deg,'
                        hexcolors.forEach((color, idx) => {
                            gradientstr += color
                            if (idx < hexcolors.length - 1) {
                                gradientstr += ','
                            }
                        })
                        gradientstr += ')'
                        buf['gradient'] = gradientstr
                    }
                    tmpColorMapData2.push(buf)
                }).catch((error) => { return })
            }
        }
        Promise.all(colorMaps.map(fetchAndPushColorMap)).then(() => {
            setColorMapData(tmpColorMapData2);
        });

    }, [colorMaps]);

    return (
        <>

            {data['is_raster'] ?
                <>
                    <p style={{
                        marginTop: 0
                    }}>Select your favorite color map:</p>

                    <div className="color-map-container">

                        {colorMapData.map((colorMap, idx) => <div
                            key={`cm_${colorMap.name}_${idx}`}
                            className="color-map-box">
                            {colorMapName === colorMap.name && <div className="color-map-box-selected"><CheckOutlined /></div>}
                            <div className="color-map-box-text">{colorMap.name}</div>
                            {colorMap.is_categorical ?
                                <>
                                    <div className="color-map-box-palette">
                                        {colorMap.colors.map((color, idxChild) =>
                                            <div
                                                key={`cm_box_${colorMap.name}_${idxChild}`}
                                                onClick={() => { setColorMapName(colorMap.name) }}
                                                className="color-map-box-item"
                                                style={{
                                                    backgroundColor: `rgb(${color[0] * 255}, ${color[1] * 255}, ${color[2] * 255})`
                                                }}>
                                            </div>
                                        )}
                                    </div>
                                </>
                                :
                                <div className="color-map-box-palette"
                                    style={{ background: colorMap.gradient, height: '30px' }}
                                    key={`cm_box_${colorMap.name}_${idx}`}
                                    onClick={() => { setColorMapName(colorMap.name) }}
                                />}
                        </div>
                        )}
                    </div>
                </>
                : null
            }
            <p>Select opacity:</p>
            <Slider defaultValue={colorMapOpacity} onChange={onChangeOpacity} />
        </>
    )
}